import { Skeleton } from './ui/skeleton'

export function LoadingList() {
  return (
    <div className='h-full w-full p-5'>
      <Skeleton className='mb-5 h-10 w-full' />
      <Skeleton className='mb-5 h-96 w-full' />
    </div>
  )
}
